const moment = require("moment");
export function fbTimestampToDate(timestamp) {
  return moment(timestamp * 1000);
}
